import React from "react";

import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';

export const ResetButton = (props) => {
	return <Button style={{ margin: "2vh", minWidth: "10vw" }} startIcon={<ClearIcon />} {...props}>{!!props.label ? props.label :"Reset"}</Button>;
}